import { useStyles } from '@archipro-design/aria';
import * as S from '@modules/project/component/about-professional/Locations.style';
import {
    locationHasDistance,
    useLocationsSortByDistance,
} from '@modules/professional/hook/use-locations-sort-by-distance';
import React, { useEffect, useState } from 'react';
import { Loader } from '@archipro-design/icons';
import { Animation } from '@fluentui/react-northstar';
import type { ProfessionalLocation } from '@modules/project/component/about-professional/Locations';
import { resolveSuburbCity } from '@modules/project/component/about-professional/Locations';

const NearestLocation = ({
    locations,
}: {
    locations: ProfessionalLocation[];
}) => {
    const { css } = useStyles();

    const [locationLoaded, setLocationLoaded] = useState<boolean | null>(null);

    const { sortedLocations, userLocationLoaded } =
        useLocationsSortByDistance<ProfessionalLocation>({ locations });

    const geoLocationAvailable = locationHasDistance(sortedLocations);

    useEffect(() => {
        setLocationLoaded(userLocationLoaded);
    }, [userLocationLoaded]);

    let nearest = geoLocationAvailable ? sortedLocations[0] : locations[0];

    return (
        <>
            {!locationLoaded ? (
                <Animation
                    name="rotateUltraSlow"
                    className={css(S.LocationSpinner)}
                >
                    <Loader size="2x" />
                </Animation>
            ) : geoLocationAvailable ? (
                <div className={css(S.Location)}>
                    <div>Nearest to you:</div>
                    <div>{resolveSuburbCity(nearest)}</div>
                </div>
            ) : (
                <div>
                    Please change your browser settings to allow location
                    services.
                </div>
            )}
        </>
    );
};

export default NearestLocation;
